import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UniAccomGuard implements CanActivate {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (route.url[0].path.includes('my-insurance')) {
      if (
        this.auth.currentUser?.university?.is_unihome_product &&
        !this.auth.hasStudentGuardInsurance &&
        this.auth.currentUser?.insuranceProducts?.length === 0
      ) {
        this.router.navigate(['/app/dashboard']).finally(() => false);
      }
    }

    // if there is a current user logged in but they don't have a uni and/or accom, they must provide this info.
    if (
      !(
        route.url[0]?.path.includes('my-insurance') &&
        route.url[1]?.path.includes('update')
      ) &&
      (!this.auth.currentUser?.accommodation ||
        !this.auth.currentUser?.university)
    ) {
      this.auth.userMustCompleteProfile = true;
      this.router.navigate(['/app/my-insurance/update']).finally(() => false);
    }
    return true;
  }
}
